import React from "react";
//import { LightBulbIcon, SparklesIcon } from '@heroicons/react/solid';

import Policy from "../../api/about_policy";
import "./policy.css"
const PolicySection = (props) => {
  return (

    <section>

      <div className="container_p">
        {Policy.map((item, index) => (
          <div className="cardpolicy" key={index}>
            <i className={item.icon1}></i>
            <h2 className="card_h2">{item.title}</h2>
            <p className="card_p m-14px">{item.subTitle}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PolicySection;
